<template>
  <div style="font-size: 14px;" class="footer">
    <div style="display: flex;justify-content: center;color:#ffffff;background: #303030;">
      <div class="contain-box footer-content" style="margin:0;">
        <div style="display: flex;">
          <div style="flex: 1;display: flex;">
            <div style="">
              <div class="title-content">买家指南</div>
              <!-- <div class="foot-item" @click="toHelpPage('6-1')">积分规则</div> -->
              <!-- <div class="foot-item" @click="toHelpPage('5-1')">隐私协议</div> -->
              <div class="foot-item" @click="toHelpPage('4-1')">售后流程</div>
              <div class="foot-item" @click="toHelpPage('3-1')">支付方式</div>
              <div class="foot-item" @click="toHelpPage('2-1')">配送方式</div>
              <div class="foot-item" @click="toHelpPage('1-1')">购物流程</div>
            </div>
            <div style="margin-left: 100px;">
              <div class="title-content">平台规则</div>
              <div class="foot-item" @click="toHelpPage('5-1')">隐私协议</div>
            </div>
            <div style="margin-left: 100px;">
              <div class="title-content">关于我们</div>
              <div class="foot-item" @click="toHelpabout(1)">关于我们</div>
              <div class="foot-item" @click="toHelpabout()">联系我们</div>
              <div class="foot-item" @click="toHelpabout()">营业执照</div>
            </div>
            <!-- <div style="margin-left: 100px;">
              <div class="foot-title">线下门店</div>
              <div class="foot-item">账户管理</div>
              <div class="foot-item">购物指南</div>
              <div class="foot-item">订单操作</div>
            </div>
            <div style="margin-left: 100px;">
              <div class="foot-title">支付方式</div>
              <div class="foot-item">账户管理</div>
              <div class="foot-item">购物指南</div>
              <div class="foot-item">订单操作</div>
            </div> -->
          </div>
          <div class="footer-service">
              <div style="width: 250px;">
                <div style="font-family: PingFang SC;font-weight: bold;font-size: 20px;color: #FFFFFF;">服务热线</div>
                <div style="font-weight: bold;font-size: 18px;line-height: 50px;color:#FFFFFF">4008-100-985</div>
                <div style="color:gray;font-size:12px;">工作时间：9:00 -18:00</div>
                <div style="margin-bottom: 10px;"></div>
                <!-- <el-button type="success" round icon="el-icon-headset">24小时客服在线</el-button> -->
            </div>
            <div>
              <div style="height: 30px;font-family: PingFang SC;font-weight: bold;font-size: 20px;color: #FFFFFF;text-align: center;">关注小程序</div>
              <div class="footer-app">
                <img src="../../../public/img/app.jpg">
              </div>
            </div>
          </div>
          
        </div>

      </div>
    </div>
    <!-- <div style="background-color: #f5f5f5;height: 40px;text-align: center;line-height: 40px;">
      申明：本网页仅供学习参考 @XXX XXX XXX
    </div> -->
  </div>

</template>

<script>
export default {
    data() {
      return {}
    },
    methods: {
      toHelpPage(openindex){
        this.$router.push({
          path: '/helpabout/help',
          query:{
            openindex:openindex
          }
        }); 
      },
      toHelpabout(data){
        this.$router.push({
          path: '/helpabout/about',
          query:{
            isdetermine:data
          }
        }); 
      }
    }
  }
</script>

<style>
  .title-content{
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
  }
  .footer{
    /* position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%,0%); */

  }
  .foot-title{
    height: 40px;
    line-height: 40px;
  }
  .foot-item{
    height: 25px;
    line-height: 25px;
    color: #666;
  }
  .foot-item:hover{
    cursor: pointer;
    color: #ED1F1F;
  }
  .footer-content{
    color: #666;
    margin-top: 50px;
    padding: 20px 0px;
    border-top: 1px solid #eee;
  }
  .footer-service{
    display: flex;
    flex: 2;
    justify-content: flex-end;
    /* border-left: 1px solid #eee; */
  }
  .footer-app{
    width: 120px;
    height: 120px;
  }
  .footer-app img{
    width: 100%;
    height: 100%;
    border: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/page/foot/index.vue